import { GuidedFlowCopy } from "../primitives/GuidedPrimitives.js";

export function GuidedProjectsView({
  rows,
  loading = false,
  ready = false,
  error = null,
  onOpenProject,
}: {
  readonly rows: readonly { readonly projectId: string; readonly name: string; readonly status: string }[];
  readonly loading?: boolean;
  readonly ready?: boolean;
  readonly error?: string | null;
  readonly onOpenProject: (projectId: string) => void;
}) {
  const initialLoading = loading && !ready;

  return (
    <section className="enrein-guided-view is-active" id="view-projects" aria-label="Projects">
      <GuidedFlowCopy title="All projects" kicker="Portfolio" />
      {initialLoading ? <p className="enrein-guided-muted">Loading projects…</p> : null}
      {error ? <p className="enrein-guided-validation">{error}</p> : null}
      {!initialLoading && rows.length === 0 ? (
        <p className="enrein-guided-muted">No projects yet. Use New project on Home to start.</p>
      ) : (
        <ul className="enrein-guided-project-list">
          {rows.map((row) => (
            <li key={row.projectId}>
              <button type="button" className="enrein-guided-project-row" onClick={() => onOpenProject(row.projectId)}>
                <strong>{row.name}</strong>
                <span className="enrein-guided-muted">{row.status}</span>
              </button>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
